module.exports = "https://r.nearpod.com/assets/media/image/prev-arrow-f184a4006b60aeaf1af7b5a28632ab8f.svg";